export default "__VITE_ASSET__441c35bb__"